// Copyright (c) 2020 Deere & Company

import './index.scss';

import AuthenticatedPage from '../../common/components/authenticated-page';
import PoolMachineMissingStdPkgCode from './poolMachineMissingStdPkgCode';
import React from 'react';

function PoolMachineMissingStdPkgCodePage () {

    return (
        <AuthenticatedPage className="atp-page atp-pool-machine-missing-std-pkg-code-page">
            <PoolMachineMissingStdPkgCode />
        </AuthenticatedPage>
    );

}
PoolMachineMissingStdPkgCodePage.displayNAme = 'PoolMachineMissingStdPkgCodePage';

export default PoolMachineMissingStdPkgCodePage;
